import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class IcustomerService {

  is_icustomer_register_component = false;
  icustomerUpdate = new EventEmitter<ZONE>();

  downloadIcustomer = new EventEmitter<boolean>();
  downloadIcustomerHistory = new EventEmitter<boolean>();
  
  private _icustomer_data: ICUSTOMER = null;
  private _icustomer_product = null;

  constructor() { }


  set set_icustomer_data(icustomer) {
    this._icustomer_data = icustomer;
  }


  get get_icustomer_data() {
    return this._icustomer_data;
  }

  set set_icustomer_products(product_list) {
    this._icustomer_product = product_list;
  }

  get get_icusomter_products() {
    return this._icustomer_product;
  }


}

export interface ICUSTOMER {
  id: number;
  name: string;
}
